function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import styled from 'styled-components';
import PropTypes from 'prop-types';
import space from '@styled-system/space';
import { spacings } from '../../../../theme/spacings';
import { breakpoints, ssBreakpoints, maxWidths } from '../../../../theme/breakpoints';
import { getCssStyle, px, breakpointsStyles } from '../../../../utils/styled-system';
var getMaxWiths = function getMaxWiths() {
  var bpKeys = Object.keys(breakpoints);
  var allMaxWidths = breakpointsStyles(bpKeys, function (bp) {
    return getCssStyle('max-width', px(maxWidths[bp]));
  });
  return allMaxWidths;
};
export var Wrapper = /*#__PURE__*/styled.div.attrs(function (_ref) {
  var theme = _ref.theme,
    props = _objectWithoutProperties(_ref, ["theme"]);
  return _objectSpread(_objectSpread({}, props), {}, {
    theme: _objectSpread(_objectSpread({}, theme), {}, {
      space: spacings,
      breakpoints: ssBreakpoints
    })
  });
}).withConfig({
  componentId: "sc-1gfa0w0-0"
})(["", ";margin-right:auto;margin-left:auto;--gutter:8px;padding-right:var(--gutter);padding-left:var(--gutter);", ""], function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? 'max-width: 100%;' : getMaxWiths();
}, space);
Wrapper.displayName = 'Wrapper';
Wrapper.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool
};